import { createDraftSafeSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { clearLogin, loginSuccess } from '../../loginView/state/loginSlice'
import { GlobalState } from '@store'
import { ExecutiveMetricsResponse, LoadExecutiveMetricsPayload } from '../types'

interface State {
  data?: ExecutiveMetricsResponse
  loading: boolean
  error: string
  requestKey: string
}

export const initialState: State = {
  loading: false,
  error: '',
  requestKey: ''
}

const slice = createSlice({
  name: 'executiveMetrics',
  initialState,
  reducers: {
    loadExecutiveMetrics: (state, action: PayloadAction<LoadExecutiveMetricsPayload>) => {
      state.loading = true
      state.error = ''
      state.requestKey = action.payload.requestId
      state.data = undefined
    },
    executiveMetricsLoaded: (
      state,
      action: PayloadAction<{
        requestKey: string
        data: ExecutiveMetricsResponse
      }>
    ) => {
      if (state.requestKey !== action.payload.requestKey) return
      state.loading = false
      state.data = action.payload.data
    },
    executiveMetricsFailed: (state, action: PayloadAction<{ requestKey: string; message: string }>) => {
      if (state.requestKey !== action.payload.requestKey) return
      state.loading = false
      state.error = action.payload.message
    },
    clearExecutiveMetrics: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(clearLogin, () => initialState)
    builder.addCase(loginSuccess, () => initialState)
  }
})

export const selectExecutiveMetrics = createDraftSafeSelector(
  [(state: GlobalState) => state.executiveMetrics],
  state => state
)
export const {
  loadExecutiveMetrics,
  executiveMetricsLoaded,
  executiveMetricsFailed,
  clearExecutiveMetrics
} = slice.actions
export default slice.reducer
